var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{ref:"save-btn",attrs:{"color":"secondary","loading":_vm.loading,"disabled":_vm.loading,"small":""},on:{"click":function($event){return _vm.$emit('click', $event)}},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('nv-circular-loader')]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.saveText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }